/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext } from "react";

export const OneSignalContext = createContext({
  initialized: false,
  isSubscribed: false,
  optIn: async () => {},
  optOut: async () => {},
  promptPush: async () => {},
});

export const useOneSignalContext = () => useContext(OneSignalContext);
